import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Spinner } from "react-bootstrap";
import Cropper from "react-easy-crop";
import { uploadbaseRequest } from "../util/uploadbase";
import getCroppedImg from "./Cropimage";
import ButtonPage from "../../comman/button/ButtonPage";

function CropbannerPage(props) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [croppedAreaPixels, setCropedareapixels] = useState(null);
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCropedareapixels(croppedAreaPixels);
  }, []);
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();

  const showCroppedImage = async () => {
    setLoader(true);
    const croppedImage = await getCroppedImg(
      props.bannerImage,
      croppedAreaPixels
    );
    let uploadbaseResponse = await uploadbaseRequest(croppedImage);
    if (uploadbaseResponse?.status === 200) {
      let getfilename = await uploadbaseResponse.json();
      props.setBannerImageArray([
        {
          preview_url: croppedImage,
          fileName: getfilename.name,
        },
      ]);
    }
    setLoader(false);
    props.setShowcrop(false);
  };

  return (
    <Modal fullscreen={true} show={props.showcrop}>
      <Modal.Body>
        <Cropper
          image={props.bannerImage}
          crop={crop}
          aspect={279/50}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
        />
      </Modal.Body>
      <Modal.Footer>
        <ButtonPage
            Text={t("pages.add_product.cancel")}
            onClick={() => props.setShowcrop(false)}
            className="button-black"
            type={"button"}
        />
        <ButtonPage
            Text={loader ? (
              <Spinner animation="border" size="sm" />
            ) : (
              t("pages.Submit")
            )}
            onClick={() => showCroppedImage()}
            className="button-submit" 
            type={"button"}
        />
      </Modal.Footer>
    </Modal>
  );
}
export default CropbannerPage;
